class PortalRecommendationProducts {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);
    if (!this.root) return;

    this.collectionHandle = this.root.dataset.collection;
    this.defaultSort = this.root.dataset.defaultSort;

    this.init();
  }

  init() {
    this.loadProducts(this.defaultSort);
    this.bindProductSelection();
  }

  loadProducts(sortValue) {
    const filterQuery = this.getSelectedFilters();
    const url = `/collections/${this.collectionHandle}?section_id=api-product-select-recommendation&sort_by=${sortValue}&${filterQuery}`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector('[id^="shopify-section"]');

        this.root.innerHTML = newSection.innerHTML;

        this.applyFilters();
        this.toggleSort();
        this.toggleFilter();
        this.applySort();
      });
  }

  bindProductSelection() {
    this.root.addEventListener('click', async (e) => {
      const card =
        e.target.closest('.product-select__product') ||
        e.target.closest('a[href*="/products/"], .product-card, .card-wrapper');

      if (card) {
        e.preventDefault();

        let variantId = card.dataset.variantId || card.querySelector('input[name="id"]')?.value;

        const title =
          card.dataset.title || card.querySelector('.card__heading, .full-unstyled-link, h3')?.innerText.trim();

        const image = card.dataset.image || card.querySelector('img')?.src;
        const vendor =
          card.dataset.vendor || card.querySelector('.card__vendor, .product-card__vendor')?.innerText.trim() || '';
        const price =
          card.dataset.price ||
          card.querySelector('.price-item--regular, .product-card__price')?.innerText.trim() ||
          '';

        if (variantId) {
          const productData = {
            variantId,
            title: title || 'Selected Product',
            image,
            vendor,
            price,
          };

          document.dispatchEvent(new CustomEvent('recommendation:product-selected', { detail: productData }));

          const popover = document.getElementById('product-select-recommendation-form');
          if (popover && typeof popover.hidePopover === 'function') {
            popover.hidePopover();
          }
        } else {
          // TODO: Add Better Error Handling
          alert('Could not select this product. Please try another.');
        }
      }
    });
  }

  applySort() {
    const sortListItems = this.root.querySelectorAll('.sort-by__list li span');
    if (!sortListItems && sortListItems.length === 0) return;

    sortListItems.forEach((item) => {
      item.addEventListener('click', () => {
        const value = item.dataset.value;
        this.loadProducts(value);
      });
    });
  }

  toggleSort() {
    const sortContainer = this.root.querySelector('.sort-by__container');
    if (!sortContainer) return;

    sortContainer.addEventListener('click', (e) => {
      if (!e.target.closest('.sort-by__list')) {
        sortContainer.classList.toggle('open');
      }
    });
  }

  toggleFilter() {
    const filterBlocks = this.root.querySelectorAll('.filter__container .filter-block');
    if (!filterBlocks || filterBlocks.length === 0) return;

    filterBlocks.forEach((block) => {
      block.addEventListener('click', (e) => {
        if (!e.target.closest('.filter-values')) {
          block.classList.toggle('open');
        }
      });
    });
  }

  getSelectedFilters() {
    const filterInputs = this.root.querySelectorAll('.filter__container input[type="checkbox"]');
    if (!filterInputs || filterInputs.length === 0) return;
    const params = new URLSearchParams();

    filterInputs.forEach((input) => {
      if (input.checked) {
        params.append(input.dataset.filterParam, input.value);
      }
    });

    return params.toString();
  }

  applyFilters() {
    const filterInputs = this.root.querySelectorAll('.filter__container input[type="checkbox"]');
    if (!filterInputs || filterInputs.length === 0) return;

    filterInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const activeSort = this.root.querySelector('.sort-by__list li.active span')?.dataset.value || this.defaultSort;

        this.loadProducts(activeSort);
      });
    });
  }
}

new PortalRecommendationProducts('#product-select-recommendation');
